var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrueIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 10.5C21 16.299 16.299 21 10.5 21C4.70101 21 0 16.299 0 10.5C0 4.70101 4.70101 0 10.5 0C16.299 0 21 4.70101 21 10.5Z",
    fill: "url(#paint0_linear_0_7974)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99881 13.5305L5.1604 10.552L4.19385 11.5591L7.99881 15.5519L16.1669 6.98064L15.2071 5.97351L7.99881 13.5305Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_7974",
    x1: 10.5,
    y1: 0,
    x2: 10.5,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EFFB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10BF60"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrueIcn);
export default __webpack_public_path__ + "static/media/trueIcn.75fb9d1e53c19ce860adeabd06062199.svg";
export { ForwardRef as ReactComponent };